// 日语
export default {
    /* 登录、注册 =======================================================0 */
    "登录": "ログイン",
    "注册": "登録",
    "忘记密码": "パスワードをお忘れですか?",
    "没有账号？马上注册": "アカウントをお持ちでない方は、今すぐご登録ください！",
    "请输入手机号": "携帯電話番号を入力してください。",
    "请输入密码": "パスワードを入力してください。",
    "请确认密码": "パスワードを確認してください。",
    "请输入邀请码": "招待コードを入力してください。",
    "密码确认失败，请重新设置": "パスワードの確認に失敗しました。リセットしてください。",
    "登录中...": "ログイン...",
    "登录成功": "ログインに成功しました",
    "注册中...": "登録手続き中です...",
    "注册成功,即将跳转首页": "登録が完了しました。まもなくホームページにリダイレクトされます。",
    "我已经知晓并同意开户协议各项条约": "私は口座開設契約のすべての条項を読み、同意します。",
    "请阅读并同意开户协议": "口座開設契約書をよくお読みになり、同意してください。",
    "已有账号？马上登录": "既にアカウントをお持ちですか？今すぐログイン",
    "请联系在线客服": "オンラインカスタマーサービスまでお問い合わせください。",
    /* 登录、注册 =======================================================1 */

    /* 首页 ============================================================0 */
    "首页": "トップページ",
    "请选择地区": "地域を選択してください",
    "全国第一福利品": "国内ナンバーワンの福祉商品",
    "为了会员权益，网站只展示 1% 资源并且不定期更新只为展示实力，如需查询预约更多资源请联系上级接待": "会員特典を保護するため、ウェブサイトには掲載されているリソースの1%のみが表示されており、その機能を紹介するために不定期に更新されています。より多くのリソースに関するお問い合わせやご予約は、直属の上司までご連絡ください。",
    "本平台所有资源真实、安全、可靠，全国空降、同城约炮选取你心仪的她，与您零距离邂逅，快加入我们吧": "このプラットフォーム上のすべてのリソースは、本物で安全かつ信頼できます。全国規模の出会いや、同じ都市内での出会いを提供しています。理想のパートナーを見つけて、実際に会ってみましょう。今すぐご参加ください！",
    "平台资源": "プラットフォームリソース",
    "昵称": "ニックネーム:",
    "类型": "タイプ:",
    "距离：点击查看": "距離：クリックして表示",
    "服务项目：激活可见": "サービス項目：アクティベーションが必要です",
    "已认证": "認証済み",
    "查看更多": "もっと見る",
    "当前地区暂无资源": "現在、この分野で利用可能なリソースはありません。",
    "服务条款": "利用規約",
    "网红、模特、空姐、嫩模、大学生、留学生，只有您想不到，没有本平台办不到": "インターネットセレブ、モデル、客室乗務員、若手モデル、大学生、留学生――あなたが想像できるものなら何でも、このプラットフォームで提供できます。",
    "服务范围": "サービス範囲",
    "同城约炮，任意地点空降，国内一二线城市当地均有，三线城市也可以通过上级预约安排": "現地での接続、どこでもの降車が可能で、中国の第一級都市と第二級都市で利用可能であり、さらに上級者を通じて第三級都市でも手配可能です。",
    "热门地区": "人気エリア",
    "更多地区": "その他の地域",
    "网红、模特、空姐、嫩模、大学生、留学生": ['インターネットセレブリティ', 'モデル', '客室乗務員', '若手モデル', '大学生', '留学生'],
    "请联系管理员激活账号": "アカウントを有効にするには、管理者にご連絡ください。",
    "请联系客服获取更多信息": "詳細については、カスタマーサービスまでお問い合わせください。",
    /* 首页 ============================================================1 */

    /* 福利 ============================================================0 */
    "福利": "福祉",
    "全部": "全て",
    /* 福利 ============================================================1 */

    /* 视频 ============================================================0 */
    "视频": "ビデオ",
    /* 视频 ============================================================1 */

    /* 我的 ============================================================0 */
    "我的": "私の",
    "余额": "バランス",
    "元": "円",
    "¥": "JP¥",
    "CNY": "JPY",
    "我的信用分": "私の信用スコア",
    "我的客服": "カスタマーサービス",
    "提现": "出金",
    "提现记录": "出金記録",
    "个人报表": "個人レポート",
    "任务记录": "タスクログ",
    "我的消息": "私のメッセージ",
    "银行卡": "銀行カード",
    "设置": "設定",
    "未配置跳转链接": "リダイレクトリンクが設定されていません",
    "功能尚未开放": "この機能はまだ利用できません。",
    /* 我的 ============================================================1 */

    /* 美女 ============================================================0 */
    "公告": "発表",
    "基本信息": "基本情報",
    "生日": "誕生日：****年**月**日",
    "身高": "高さ：***cm",
    "体重": "重量：***kg",
    "胸围": "胸囲：***",
    "所在位置：已隐藏，联系客服激活可见": "場所：非公開。有効化および閲覧するには、カスタマーサービスにお問い合わせください。",
    "联系方式：已隐藏，联系客服激活可见": "連絡先情報：非公開。閲覧するにはカスタマーサービスにお問い合わせください。",
    "服务项目：激活可见": "サービスの詳細：有効化後に表示されます。",
    "祝愿各位会员每天都能遇到美好的恋情，享受快乐的夜晚": "会員の皆様が毎日、素敵なロマンスと楽しい夜を過ごせますように！",
    "立即约她": "すぐにデートに誘ってみて",
    "联系专属客服接待": "専任のカスタマーサービス担当者にご連絡ください。",
    /* 美女 ============================================================1 */

    /* 个人报表 ========================================================0 */
    "盈利金额": "利益額",
    "盈利计算公式": "利益計算式",
    "任务金额": "タスク金額",
    "充值金额": "チャージ金額",
    "提现金额": "出金金額",
    "中奖金额": "賞金",
    /* 个人报表 ========================================================1 */

    /* 播放器 ==========================================================0 */
    "播放器": "プレーヤー",
    "热门推荐": "人気のおすすめ商品",
    "提示": "ヒント",
    "播放次数已用完，请联系专属客服": "プレイ回数の上限に達しました。専用カスタマーサービスまでお問い合わせください。",
    /* 播放器 ==========================================================1 */

    /* 下注 ===========================================================0 */
    "彩票": "宝くじ",
    "查看历史开奖": "歴史記録",
    "开奖期数": "抽選回数",
    "中奖号码": "当選番号",
    "下单": "注文する",
    "下注号码": "賭けの数字",
    "请选择下注号码": "賭けたい数字を選択してください。",
    "每注金额": "1回の賭け金あたりの金額",
    "请输入金额": "金額を入力してください。",
    "总计": "合計",
    "订单": "注文",
    "清空": "クリア",
    "余额不足，请联系客服充值": "残高不足のため、カスタマーサービスにご連絡の上、チャージをお願いいたします。",
    "付款功能未开通，请联系在线客服": "お支払い機能はご利用いただけません。オンラインカスタマーサービスまでお問い合わせください。",
    "付款中...": "お支払い処理中です…",
    "付款成功": "支払いが完了しました",
    /* 下注 ===========================================================1 */

    /* 任务记录 =======================================================0 */
    "暂无记录": "記録がありません",
    "待开奖": "宝くじの抽選は保留中です",
    "订单金额": "注文金額:",
    "中奖金额": "賞金:",
    "下注时间": "賭けの時間:",
    "开奖时间": "宝くじの抽選時間:",
    "隐藏详情": "詳細を非表示にする",
    "查看详情": "詳細を確認してください",
    "投注号码": "賭けの数字:",
    "投注金额": "賭け金:",
    /* 任务记录 =======================================================1 */

    /* 银行卡 =========================================================0 */
    "银行名称": "銀行名",
    "银行卡号": "銀行カード番号",
    "持卡人姓名": "名前",
    "手机号": "電話番号",
    "点击选择银行": "銀行を選択するにはクリックしてください",
    "请填写银行卡号": "銀行カード番号を入力してください。",
    "请填写持卡人姓名": "カード名義人の氏名をご記入ください。",
    "请填写预留手机号": "ご提供いただいた携帯電話番号を入力してください。",
    "添加银行卡": "銀行カードを追加する",
    "绑定银行卡": "銀行カードをリンクする",
    "提示:请绑定大型商业银行, 如需修改, 请您联系在线客服": "注：口座は主要な商業銀行に紐付けてください。変更が必要な場合は、オンラインカスタマーサービスまでご連絡ください。",
    "尊敬的用户,为了保障您的资金安全,请您绑定您的真实姓名和设置取款密码,如果姓名与开户名不一致,将无法取款": "お客様へ、お客様の資金の安全を確保するため、実名をご登録いただき、出金用パスワードを設定してください。登録名義が口座名義人と一致しない場合、資金を引き出すことはできません。",
    "请绑定大型商业银行, 如需修改, 请您联系在线客服": "お客様のアカウントを大手商業銀行にリンクしてください。変更が必要な場合は、オンラインカスタマーサービスまでご連絡ください。",
    /* 银行卡 =========================================================1 */

    /* 提现 ===========================================================0 */
    "记录": "出金記録",
    "限额说明": "割り当ての説明",
    "单笔交易最低限额": "最低取引限度額",
    "单笔交易最高限额": "最大取引限度額",
    "每天可提款次数": "1日の引き出し限度額",
    "到账时间": "到着時間：通常は約5分ですが、最短で2分です。",
    "请输入资金密码": "資金のパスワードを入力してください。",
    "请联系专属客服": "担当のカスタマーサービス担当者までご連絡ください。",
    "取消": "キャンセル",
    "提交中...": "送信中...",
    "说明": "例示する",
    "提交时间": "提出時間",
    "审核时间": "レビュー時間",
    "审核中": "審査中",
    /* 提现 ===========================================================1 */

    /* 设置 ===========================================================0 */
    "头像": "アバター",
    "点击选择头像": "プロフィール写真を選択するにはクリックしてください",
    "姓名": "名前",
    "点击设置姓名": "クリックして名前を設定",
    "性别": "性別",
    "男": "男",
    "女": "女",
    "未知": "未知",
    "点击选择性别": "性別を選択するにはクリックしてください",
    "登录密码": "ログインパスワード",
    "去修改": "変更へ移動",
    "资金密码": "資金コード",
    "如需修改，请联系专属客服": "変更をご希望の場合は、弊社の専用カスタマーサービスまでご連絡ください。",
    "设置动词": "設定",
    "语言": "言語",
    "切换语言": "言語を切り替える",
    "退出登录": "ログアウト",
    "选择头像": "アバターを選択",
    "确定": "もちろん",
    "设置姓名": "セット名",
    "请输入您的姓名": "お名前を入力してください。",
    "请选择您的性别": "性別を選択してください。",
    "你已设置姓名，如需修改，请联系专属客服": "既にお名前を設定済みです。変更をご希望の場合は、担当のカスタマーサービス担当者までご連絡ください。",
    /* 设置 ===========================================================1 */

    /* 选择语言 ===========================================================0 */
    "选择语言": "言語を選択してください",
    "正在切换语言...": "言語の切り替え...",
    /* 选择语言 ===========================================================1 */

    /* 修改登录密 =========================================================0 */
    "修改登录密码": "ログインパスワードを変更する",
    "旧密码": "以前のパスワード",
    "请输入旧密码": "以前のパスワードを入力してください。",
    "新密码": "新しいパスワード",
    "请输入新密码": "新しいパスワードを入力してください。",
    "确认密码": "パスワードを認証する",
    "请确认新密码": "新しいパスワードを確認してください。",
    "修改": "改訂",
    "修改中...": "改訂中...",
    "修改成功，请重新登录": "変更が完了しました。再度ログインしてください。",
    /* 修改登录密 =========================================================1 */

    /* 设置资金密码 =======================================================1 */
    "设置资金密码": "資金にパスワードを設定してください",
    "资金密码必须由四位数字组成": "資金のパスワードは4桁の数字でなければなりません。",
    "设置中...": "設定で...",
    "设置成功": "セットアップに成功しました",
    /* 设置资金密码 =======================================================1 */
}